import { delta as fDelta } from '../format'
import type { ReactNode } from 'react'

/**
 * Eine Kennzahl als Kachel.
 *
 * Die Zahl ist das Groesste auf der Kachel, das Etikett das Kleinste.
 * Die Veraenderung traegt Pfeil UND Vorzeichen, nicht nur Farbe - sonst
 * bliebe die Aussage bei Rotgruenschwaeche im Dunkeln.
 */
export function Kennzahl({
  etikett, wert, fuss, veraenderung, verglichenMit, umgekehrt = false,
}: {
  etikett: ReactNode
  wert: string
  fuss?: string
  veraenderung?: number | null
  verglichenMit?: string
  umgekehrt?: boolean
}) {
  const v = veraenderung
  const richtung = v === null || v === undefined ? null
    : Math.abs(v) < 0.05 ? 'gleich' : v > 0 ? 'auf' : 'ab'
  // Bei Stornos ist mehr nicht besser. Die Kachel sagt, welche Richtung
  // gut ist, statt es bei allen Zahlen gleich einzufaerben.
  const gut = richtung === 'gleich' ? 'gleich'
    : umgekehrt ? (richtung === 'auf' ? 'ab' : 'auf') : richtung

  return (
    <div className="karte kennzahl">
      <div className="etikett">{etikett}</div>
      <div className="wert">{wert}</div>
      <div className="fuss">
        {richtung && (
          <span className={`delta ${gut}`}>
            <span aria-hidden="true">
              {richtung === 'auf' ? '▲' : richtung === 'ab' ? '▼' : '–'}
            </span>
            {fDelta(v)}
          </span>
        )}
        {/* Der Beisatz nur mit seiner Zahl.
            Ohne diese Bedingung stand unter 7.679,18 € in Ulm
            „zum selben Wochentag" ohne Vergleichswert da — der Mittwoch
            der Vorwoche war für diesen Standort nicht eingelesen. Das
            liest sich wie ein Vergleich, der leer ausgegangen ist,
            und nicht wie einer, den es nicht gab. */}
        {richtung && verglichenMit
          && <span className="dezent">{verglichenMit}</span>}
        {fuss && <span className="dezent">{fuss}</span>}
      </div>
    </div>
  )
}
